import configService from "../../services/configService";
import haugazelService from "../../services/haugazelService";
import router from "../../router";

export default {
  namespaced: true,
  state: {
    ranges: [],
    simulationProducts: []
  },
  mutations: {
    setRanges(state, value) {
      state.ranges = value;
    },
    setSimulationProducts(state, value) {
      state.simulationProducts = value;
    }
  },
  actions: {
    async getPodium(context) {
      try {
        let podiumParams = await context.dispatch("getPodiumData");
        let response = await haugazelService.getPodium(podiumParams);

        context.dispatch("setSimulationProducts", response);
        context.dispatch("setRanges", response);
      } catch (error) {
        throw error;
      }
    },
    setRanges(context, products) {
      products = products.sort((a, b) => (a.order > b.order ? 1 : -1));
      let ranges = [...new Set(products.map(x => x.range))];

      context.commit("setRanges", ranges);
    },
    setSimulationProducts(context, products) {
      let electricityProducts = products.filter(
        product => product.energy === "electricity"
      );
      let gasProducts = products.filter(product => product.energy === "gas");

      let simulationProducts = {
        electricity: electricityProducts.map(item => {
          return item.hgzId;
        }),
        gas: gasProducts.map(item => {
          return item.hgzId;
        })
      };

      context.commit("setSimulationProducts", simulationProducts);
    },
    getPodiumData(context) {
      let podiumData = {
        customerType: context.rootState.contact.isPro ? "pro" : "resi",
        area: context.rootState.calculation.area
      };

      if (router.currentRoute.query.agent) {
        podiumData["agent"] = router.currentRoute.query.agent;
      }

      if (router.currentRoute.query.campaign) {
        podiumData["campaign"] = router.currentRoute.query.campaign;
      }

      return podiumData;
    }
  },
  getters: {
    rangesDesktop: state => {
      let ranges = state.ranges;

      if (ranges.length > 1) {
        let temp = ranges[0];
        ranges[0] = ranges[1];
        ranges[1] = temp;
      }

      return ranges;
    },
    rangesMobile: state => {
      return state.ranges.reverse();
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/podium.js